import { useEffect, useState } from 'react';

interface UseSearchParamsReturnValues {
  isLoading: boolean;
  paramValues: Record<string, string>;
}

const useSearchParams = (paramsToEvaluate: string[]): UseSearchParamsReturnValues => {
  const [paramValues, setParamValues] = useState<Record<string, string>>({});
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    if (!window?.location?.search) {
      setIsLoading(false);
      return;
    }

    const params = new window.URLSearchParams(window.location.search);

    const paramMatches = paramsToEvaluate.reduce((matches, param) => {
      if (params.has(param)) {
        matches[param] = params.get(param);
      }
      return matches;
    }, {});

    setIsLoading(false);
    setParamValues({ ...paramMatches });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    isLoading,
    paramValues,
  };
};

export default useSearchParams;
